export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_REFRESH = "AUTH_REFRESH";
export const AUTH_REFRESH_PERFORM = "AUTH_REFRESH_PERFORM";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export const PERMISSIONS_REQUEST = "PERMISSIONS_REQUEST";